/*
==========================================================
USER STATUS
==========================================================
*/

export const USER_STATUS = Object.freeze({

  /*
  ==========================================================
  ACTIVE
  ==========================================================
  */

  ACTIVE: {

    id: "active",

    label: "Active"

  },

  /*
  ==========================================================
  INACTIVE
  ==========================================================
  */

  INACTIVE: {

    id: "inactive",

    label: "Inactive"

  },

  /*
  ==========================================================
  SUSPENDED
  ==========================================================
  */

  SUSPENDED: {

    id: "suspended",

    label: "Suspended"

  }

});

export default USER_STATUS;